import axios from "axios";

//const API_BASE_URL = "https://api.iotrips.in/auth"; // 💥 Use your Spring Boot URL

const API_BASE_URL = "http://localhost:8080/auth"; // 💥 Use your Spring Boot URL

export const signup = async (signupData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/signup`, signupData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : "Signup failed!";
  }
};

export const login = async (phone, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/login`, null, {
      params: { phone, password },
    });
    localStorage.setItem("user", JSON.stringify(response.data));
    window.dispatchEvent(new Event("userLoggedIn"));

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : "Login failed!";
  }
};

export const getCurrentWeather = async () => {
  try {
    const response = await axios.get("https://api.open-meteo.com/v1/forecast", {
      params: {
        latitude: 17.385044,
        longitude: 78.486671,
        current_weather: true,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : "Weather fetch failed!";
  }
};

export const sendOtp = (phone) => {
  return axios.post(`${API_BASE_URL}/send-otp`, { phone });
};

export const verifyOtp = async (phone, otp) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/verify-otp`, {
      phone,
      otp,
    });

    if (response.data && response.data.user) {
      localStorage.setItem("user", JSON.stringify(response.data.user));
      window.dispatchEvent(new Event("userLoggedIn"));
    }

    return response;
  } catch (error) {
    throw error.response ? error.response.data : "OTP verification failed!";
  }
};

export const completeSignup = async ({ phone, name, email }) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/complete-otp-signup`, {
      phone,
      name,
      email,
    });

    if (response.data) {
      localStorage.setItem("user", JSON.stringify(response.data));
      window.dispatchEvent(new Event("userLoggedIn"));
    }

    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : "Signup failed!";
  }
};
